import { render, staticRenderFns } from "./literatureAuthor.vue?vue&type=template&id=f6823c06&scoped=true&"
import script from "./literatureAuthor.vue?vue&type=script&lang=js&"
export * from "./literatureAuthor.vue?vue&type=script&lang=js&"
import style0 from "./literatureAuthor.vue?vue&type=style&index=0&id=f6823c06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6823c06",
  null
  
)

export default component.exports